export default function selectJiraSearchedIssuesIds(state, { source }) {
  return state.integrations.thirdPartyData[source].searchedIssues.ids
}
